// extracted by mini-css-extract-plugin
export default {"step_col":"SpecialPackage_step_col__0gYRJ","title":"SpecialPackage_title__lYH3G","step_title":"SpecialPackage_step_title__xGuVV"};